export default {
    AGENDADO : 1,
    DUPLICIDADE: 2,
    FALTOU: 3,
    OUTROS: 4,
    REALIZADO: 5,
    PENDENTE_ASSINATURA: 6,
    ASSINADO: 7,
    NAO_REALIZADO: 8,
    NOVA_COLETA: 9,
    PENDENTE_ENTREGA: 10,
    ENTREGUE: 11,
    CANCELADO: 12,
}